import defaultStore from "./default-store";
import prepStore from "./prep-store";

const store = function () {
    switch (window.location.pathname.split("/")[1]) {
        case "prep":
            return prepStore;
            break;
        default:
            return defaultStore;
    }
};

export default store;
